import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';

@Component({
  selector: 'send-reminder',
  templateUrl: './send-reminder.component.html',
  standalone: true,
  imports: [
    AfTranslateDirective
  ]
})
export class SendReminderComponent {
  task:any = this.dialogConfig.data.task;

  constructor(private translate: AfTranslateFactory,
    private apiService: ApiServiceService,
    private dialogRef: DynamicDialogRef<SendReminderComponent>,
    private dialogConfig: DynamicDialogConfig) { }


  send(option: number){
    this.apiService.add('tasks/meetingreminder/' + this.task.taskId + '/' + option)
      .then(() => {
        this.handleAccept();
      });
  }

  handleAccept() {
    this.dialogRef.close({
      result: 'ok',
      text: this.translate.instant('send-reminder.successfully-sent')
    })
  }

  handleDismiss(){
    this.dialogRef.close({result: 'cancel'});
  }
}
